import React, { useState, useCallback } from 'react';
import '../styles/WhatsAppShare.css';

const CONTATO = '5511956922677';

function buildModelos(p) {
  const link = `https://wa.me/${CONTATO}?text=${encodeURIComponent(`Interesse: ${p.titulo}`)}`;
  const preco = `R$ ${parseFloat(p.meuPreco).toFixed(2)}`;
  const precoWeb = p.precoWeb && p.precoWeb !== '0'
    ? `R$ ${parseFloat(p.precoWeb).toFixed(2)}`
    : null;
  const economia = precoWeb
    ? `R$ ${(parseFloat(p.precoWeb) - parseFloat(p.meuPreco)).toFixed(2)}`
    : null;
  const dim = [p.altura && `${p.altura}cm`, p.largura && `${p.largura}cm`, p.comprimento && `${p.comprimento}cm`]
    .filter(Boolean).join(' x ');

  return [
`🛍️ *${p.titulo}*
${precoWeb ? `~~${precoWeb}~~ ` : ''}*${preco}*
${dim ? `📐 ${dim}\n` : ''}
👉 Interesse? Chama aqui: ${link}`,

`✨ *${p.titulo}* ✨

💲 Preço especial: *${preco}*${precoWeb ? `\n(na web por ${precoWeb})` : ''}
${dim ? `📏 Medidas: ${dim}\n` : ''}
📩 Me chama para saber mais:
${link}`,

`🔥 *OFERTA DO DIA* 🔥

📦 *${p.titulo}*
💰 Por apenas *${preco}*${precoWeb ? ` (de ${precoWeb})` : ''}
${dim ? `📐 Dimensões: ${dim}\n` : ''}
👇 Clique e me chame no WhatsApp:
${link}`,

`━━━━━━━━━━━━━━━━━━
🏷️ *${p.titulo}*
━━━━━━━━━━━━━━━━━━
${precoWeb ? `De: ~~${precoWeb}~~\n` : ''}💵 *${preco}*
${dim ? `📐 ${dim}\n` : ''}
✅ Disponível agora!
📲 ${link}`,

`👋 Oi pessoal!

Olha que produto incrível que tenho pra vocês:

🎁 *${p.titulo}*
💰 Valor: *${preco}*${precoWeb ? ` — site cobra ${precoWeb}!` : ''}
${dim ? `📦 Tamanho: ${dim}\n` : ''}
Ficou interessado? Me manda mensagem! 💬
${link}`,

`🌟 PRODUTO EM DESTAQUE 🌟

*${p.titulo}*
${precoWeb ? `❌ Preço normal: ${precoWeb}\n` : ''}✅ Meu preço: *${preco}*
${dim ? `📐 Medidas: ${dim}\n` : ''}
Quer levar? Clica aqui 👇
${link}`,

`📢 *NOVIDADE NO CATÁLOGO!*

*${p.titulo}*

💲 Preço: *${preco}*${precoWeb ? `\n📊 Comparativo web: ${precoWeb}` : ''}
${dim ? `📐 ${dim}` : ''}

Manda mensagem pra garantir o seu! 😍
${link}`,

`╔════════════════╗
║  *${p.titulo}*
╚════════════════╝

💰 Investimento: *${preco}*
${precoWeb ? `🌐 Web: ${precoWeb}\n` : ''}${dim ? `📐 Dimensões: ${dim}\n` : ''}
📩 Entre em contato:
${link}`,

`Boa tarde, galera! 🌞

Hoje tenho *${p.titulo}* disponível!

💵 Preço: *${preco}*${precoWeb ? ` (web: ${precoWeb})` : ''}
${dim ? `📦 Medidas: ${dim}\n` : ''}
Chama no particular pra mais infos! 👇
${link}`,

`🎯 *SEM ENROLAÇÃO:*

*${p.titulo}*

💲 *${preco}*${economia ? ` — você economiza ${economia}!` : ''}
${dim ? `📐 ${dim}\n` : ''}
Clica e já me chama: ${link}`,

`🛒 *DISPONÍVEL AGORA*

📦 *${p.titulo}*

🏷️ Preço: *${preco}*
${precoWeb ? `🔖 Na internet: ${precoWeb}\n` : ''}${dim ? `📏 ${dim}\n` : ''}
Aproveite enquanto tem! ⚡
👉 ${link}`,

`Oi pessoal! 👋😊

Chegou mais um produto incrível:

🎁 *${p.titulo}*
💰 Valor: *${preco}*${precoWeb ? `\n(web: ${precoWeb})` : ''}
${dim ? `📐 Medidas: ${dim}\n` : ''}
Ficou interessado? Me chama! 😊
${link}`,

`━━━━━━━━━━━━━━━━
🔷 *${p.titulo}*
━━━━━━━━━━━━━━━━

✅ *${preco}*${precoWeb ? `  |  🌐 web: ${precoWeb}` : ''}
${dim ? `📐 ${dim}\n` : ''}
💬 Clique para entrar em contato:
${link}`,

`🔔 *ATENÇÃO PESSOAL!* 🔔

Produto disponível: *${p.titulo}*

💰 Preço: *${preco}*${precoWeb ? `\n(site vende por ${precoWeb})` : ''}
${dim ? `📦 ${dim}\n` : ''}
Quantidade limitada! Garanta já:
${link}`,

`*${p.titulo}*

${precoWeb ? `Preço web: ~~${precoWeb}~~\n` : ''}🤑 *Meu preço: ${preco}*
${dim ? `📐 ${dim}\n` : ''}
Interessado? Só clicar:
${link}`,

`🌈 *Olha que achado!*

*${p.titulo}* 🛍️

Preço: *${preco}*${precoWeb ? ` — economize em relação ao site (${precoWeb})` : ''}
${dim ? `📐 Dimensões: ${dim}\n` : ''}
👇 Me manda mensagem agora:
${link}`,

`💼 *CATÁLOGO DE PRODUTOS*

📌 *${p.titulo}*
💲 Valor: *${preco}*
${precoWeb ? `🌐 Referência web: ${precoWeb}\n` : ''}${dim ? `📏 Medidas: ${dim}\n` : ''}
📲 Solicite mais informações:
${link}`,

`Boa noite! 🌙

Deixa eu mostrar esse produto incrível:

*${p.titulo}*
💰 *${preco}* ${precoWeb ? `(contra ${precoWeb} no mercado)` : ''}
${dim ? `📐 ${dim}\n` : ''}
Quer saber mais? Me chama 😊
${link}`,

`⭐ *PRODUTO PREMIUM* ⭐

*${p.titulo}*

🏷️ Por apenas *${preco}*
${precoWeb ? `💡 Na web você pagaria ${precoWeb}\n` : ''}${dim ? `📐 ${dim}\n` : ''}
Chama aqui:
${link}`,

`🎉 *OLHA QUE OPORTUNIDADE!* 🎉

*${p.titulo}*

💰 Apenas *${preco}*
${precoWeb ? `🔴 De ${precoWeb} por ${preco}!\n` : ''}${dim ? `📦 ${dim}\n` : ''}
Garante o seu agora! 👇
${link}`,
  ];
}

function WhatsAppShare({ product, onClose }) {
  const modelos = buildModelos(product);
  const [modeloIdx, setModeloIdx] = useState(0);
  const [verImagem, setVerImagem] = useState(false);
  const [fotoIdx, setFotoIdx] = useState(0);
  const [editando, setEditando] = useState(false);
  const [copiado, setCopiado] = useState(false);

  const imagens = (product.imagens && product.imagens.length)
    ? product.imagens
    : (product.imagem ? [product.imagem] : []);
  const temImagens = imagens.length > 0;

  const [mensagens, setMensagens] = useState(() => {
    const saved = localStorage.getItem('msg_' + product.id);
    return saved ? JSON.parse(saved) : modelos;
  });

  const sortear = useCallback(() => {
    setModeloIdx(Math.floor(Math.random() * mensagens.length));
  }, [mensagens.length]);

  const mensagemAtual = mensagens[modeloIdx];

  const copiarMensagem = async () => {
    try {
      await navigator.clipboard.writeText(mensagemAtual);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (err) {
      alert('Erro ao copiar. Selecione e copie manualmente.');
    }
  };

  const salvarMensagem = () => {
    const novas = [...mensagens];
    novas[modeloIdx] = document.getElementById('msg-edit').value;
    setMensagens(novas);
    localStorage.setItem('msg_' + product.id, JSON.stringify(novas));
    setEditando(false);
  };

  return (
    <div className="whatsapp-modal-overlay" onClick={onClose}>

      {verImagem && temImagens && (
        <div className="imagem-fullscreen" onClick={() => setVerImagem(false)}>
          <div className="imagem-fullscreen-box" onClick={e => e.stopPropagation()}>
            <p className="imagem-fullscreen-hint">
              Clique com o <strong>botão direito</strong> na imagem → <strong>Copiar imagem</strong>
            </p>
            <img src={imagens[fotoIdx]} alt={product.titulo} />
            {imagens.length > 1 && (
              <div className="galeria-nav-row">
                <button className="galeria-nav-btn" onClick={() => setFotoIdx(i => (i - 1 + imagens.length) % imagens.length)}>‹</button>
                <span className="galeria-nav-count">{fotoIdx + 1} / {imagens.length}</span>
                <button className="galeria-nav-btn" onClick={() => setFotoIdx(i => (i + 1) % imagens.length)}>›</button>
              </div>
            )}
            {imagens.length > 1 && (
              <div className="galeria-thumbs-row">
                {imagens.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Foto ${i + 1}`}
                    className={`galeria-thumb-mini ${i === fotoIdx ? 'ativo' : ''}`}
                    onClick={() => setFotoIdx(i)}
                  />
                ))}
              </div>
            )}
            <button className="btn-fechar-img" onClick={() => setVerImagem(false)}>✕ Fechar</button>
          </div>
        </div>
      )}

      <div className="whatsapp-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>💬 {editando ? 'Editar' : 'Enviar'} Mensagem</h2>

        <div className="modal-content">

          <div className="acoes-principais">
            {temImagens && (
              <button className="btn-acao" onClick={() => setVerImagem(true)}>
                📷 Ver imagem para copiar
              </button>
            )}
            {!editando && (
              <>
                <button className={`btn-acao ${copiado ? 'ok' : ''}`} onClick={copiarMensagem}>
                  {copiado ? '✅ Copiada!' : '📋 Copiar mensagem'}
                </button>
                <button className="btn-acao" onClick={() => setEditando(true)}>
                  ✏️ Editar
                </button>
              </>
            )}
          </div>

          {temImagens && (
            <div className="imagem-mini" onClick={() => { setFotoIdx(0); setVerImagem(true); }}>
              <img src={imagens[0]} alt={product.titulo} />
              {imagens.length > 1 && (
                <span className="imagem-multi-count">+{imagens.length - 1} fotos</span>
              )}
              <span className="imagem-mini-hint">Clique para ver grande e copiar com botão direito</span>
            </div>
          )}

          {!editando && (
            <>
              <div className="modelos-header">
                <span className="modelo-label">Modelo {modeloIdx + 1} de {mensagens.length}</span>
                <div className="modelos-nav">
                  <button className="nav-btn" onClick={() => setModeloIdx(i => (i - 1 + mensagens.length) % mensagens.length)}>‹</button>
                  <button className="btn-sortear" onClick={sortear}>🎲 Sortear</button>
                  <button className="nav-btn" onClick={() => setModeloIdx(i => (i + 1) % mensagens.length)}>›</button>
                </div>
              </div>

              <div className="modelos-grid">
                {mensagens.map((_, i) => (
                  <button
                    key={i}
                    className={`modelo-thumb ${i === modeloIdx ? 'ativo' : ''}`}
                    onClick={() => setModeloIdx(i)}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </>
          )}

          <div className="message-preview-section">
            <div className="preview-header">
              <span>{editando ? 'Editando' : 'Prévia'} — Modelo {modeloIdx + 1}</span>
            </div>
            {editando ? (
              <textarea
                id="msg-edit"
                className="message-edit"
                defaultValue={mensagemAtual}
              />
            ) : (
              <div className="message-preview">
                <pre>{mensagemAtual}</pre>
              </div>
            )}
          </div>

          {editando && (
            <div className="edit-botoes">
              <button className="btn-salvar-msg" onClick={salvarMensagem}>✓ Salvar</button>
              <button className="btn-cancelar-msg" onClick={() => setEditando(false)}>Cancelar</button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default WhatsAppShare;
